<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: 1500px;").mb-5
        thead
          tr
            th(style="width: 80px;" rowspan="2")
              div {{ $t('ui.time') }}
            th(style="width: 450px;" rowspan="2")
              div {{ $t('ui.event') }}
            th(colspan="7")
              div.text-center {{ $t('ui.full_time') }}
            th(colspan="7")
              div.text-center {{ $t('ui.half_time') }}
          tr
            th(style="width: 100px;")
              div.text-right {{ $t('ui.ml') }}
            th(colspan="2" style="width: 140px;")
              div.text-right {{ $t('ui.hdp') }}
            th(colspan="2" style="width: 140px;")
              div.text-right {{ $t('ui.ou') }}
            th(style="width: 100px;")
              div.text-right {{ $t('ui.oe') }}
            th(style="width: 100px;")
              div.text-right {{ $t('ui.onextwo') }}
            th(style="width: 100px;")
              div.text-right {{ $t('ui.ml') }}
            th(colspan="2" style="width: 140px;")
              div.text-right {{ $t('ui.hdp') }}
            th(colspan="2" style="width: 140px;")
              div.text-right {{ $t('ui.ou') }}
            th(style="width: 100px;")
              div.text-right {{ $t('ui.oe') }}
            th(style="width: 100px;")
              div.text-right {{ $t('ui.onextwo') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
              div(v-if="item.ot") OT : {{ item.ot }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;")
              div(:class="{'up': item.fmlh_blink }") {{ item.fmlh }}
              div(:class="{'up': item.fmla_blink }") {{ item.fmla }}
            td(style="width: 40px;").text-muted
              div(:class="{'up': item.fhdp_blink }") {{ item.fhdpt == 'H' ? item.fhdp : ' ' }} &nbsp;
              div(:class="{'up': item.fhdp_blink }") {{ item.fhdpt == 'A' ? item.fhdp : ' ' }} &nbsp;
            td(style="width: 100px;").text-right
              div(:class="{'up': item.fhdph_blink }") {{ item.fhdph }}
              div(:class="{'up': item.fhdpa_blink }") {{ item.fhdpa }}
            td(style="width: 40px;").text-muted
              div(:class="{'up': item.fou_blink }") {{ item.fou }}
            td(style="width: 100px;").text-right
              div(:class="{'up': item.fover_blink }") {{ item.fover }}
              div(:class="{'up': item.funder_blink }") {{ item.funder }}
            td(style="width: 100px;").text-right
              div(:class="{'up': item.fodd_blink }") {{ item.fodd }}
              div(:class="{'up': item.feven_blink }") {{ item.feven }}
            td(style="width: 100px;").text-right
              div(:class="{'up': item.f1_blink }") {{ item.f1 }}
              div(:class="{'up': item.f2_blink }") {{ item.f2 }}
              div(:class="{'up': item.fx_blink }") {{ item.fx }}
            td(style="width: 100px;")
              div(:class="{'up': item.hmlh_blink }") {{ item.hmlh }}
              div(:class="{'up': item.hmla_blink }") {{ item.hmla }}
            td(style="width: 40px;").text-muted
              div(:class="{'up': item.hhdp_blink }") {{ item.hhdpt == 'H' ? item.hhdp : ' ' }} &nbsp;
              div(:class="{'up': item.hhdp_blink }") {{ item.hhdpt == 'A' ? item.hhdp : ' ' }} &nbsp;
            td(style="width: 100px;").text-right
              div(:class="{'up': item.hhdph_blink }") {{ item.hhdph }}
              div(:class="{'up': item.hhdpa_blink }") {{ item.hhdpa }}
            td(style="width: 40px;").text-muted
              div(:class="{'up': item.hou_blink }") {{ item.hou }}
            td(style="width: 100px;").text-right
              div(:class="{'up': item.hover_blink }") {{ item.hover }}
              div(:class="{'up': item.hunder_blink }") {{ item.hunder }}
            td(style="width: 100px;").text-right
              div(:class="{'up': item.hodd_blink }") {{ item.hodd }}
              div(:class="{'up': item.heven_blink }") {{ item.heven }}
            td(style="width: 100px;").text-right
              div(:class="{'up': item.h1_blink }") {{ item.h1 }}
              div(:class="{'up': item.h2_blink }") {{ item.h2 }}
              div(:class="{'up': item.hx_blink }") {{ item.hx }}
</template>

<script>

export default {
  components: {
  },
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
// .fixed-header-table {
//   thead tr th {
//     background: darkgray !important;
//   }
// }

// .fixed-header-table {
//   thead tr:nth-child(1) th{
//     position: sticky;
//     top: 0;
//     z-index: 10;
//   }
// }

// .fixed-header-table {
//   thead tr:nth-child(2) th{
//     position: sticky;
//     top: 29px !important;
//     z-index: 10;
//   }
// }
</style>
